// Selo de status (pílula colorida). Codifica as cores que já são usadas em vários
// lugares do sistema pra "presente/ausente/justificado", "ativo/pendente", etc.:
// verde = sucesso, vermelho = erro/crítico, azul = informação, âmbar = pendente.
// Disponível pra telas novas — não migramos as existentes (ex.: StatusBadge em
// DailyReport.jsx), já que isso seria só cosmético sem duplicação real a resolver.
import React from 'react';

const TONES = {
  success: 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400',
  danger: 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400',
  info: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400',
  warning: 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400',
  neutral: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300',
};

export default function Badge({ children, tone = 'neutral', className = '' }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium capitalize ${TONES[tone] || TONES.neutral} ${className}`}
    >
      {children}
    </span>
  );
}
